import { searchSpecies } from './searchSpecies'
import { filterSpecies } from './filterSpecies'
import { sortSpecies } from './sortSpecies'

export const applySpeciesCriteriaMetPipeline = (speciesList = [], options = {}) => {
  const {
    search = '',
    taxonomicGroup = 'all',
    criteriaStatus = 'all',
    underAssessment = 'all',
    sort = null
  } = options

  const searched = searchSpecies(speciesList, search)
  const filtered = filterSpecies(searched, { taxonomicGroup, criteriaStatus, underAssessment })
  return sortSpecies(filtered, sort)
}

export * from './constants'
export * from './getCriteriaStatus'
export * from './searchSpecies'
export * from './filterSpecies'
export * from './sortSpecies'
